export const TWA_DOWNLOAD_SRC =
  (import.meta.env.VITE_TWA_DOWNLOAD_SRC_STATIC as string | undefined) || ''

export const FRONT_HOST =
  (import.meta.env.VITE_FRONT_HOST as string | undefined) || ''
